import React from 'react';
import styled from 'styled-components';
import ActionButton from '@westwing/ui-kit/ActionButton';
import Text from '../Text/StyledText';
import useTranslator from '../../../hooks/useTranslator';

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50vh;
    padding: 0 5px;
`;

const Inner = styled.div`
    text-align: center;
`;

const RetryButton = styled(ActionButton)`
    margin-top: 20px;
    margin-bottom: 5px;
    max-width: 200px;
`;

const GenericErrorRetry = () => {
    const t = useTranslator();

    const handleButtonClick = () => window.location.reload(true);

    return (
        <Wrapper>
            <Inner>
                <Text textType="button">
                    {t('There was an error. Please check your internet connection and try again.')}
                </Text>
                <RetryButton onClick={handleButtonClick} kind="primary">
                    {t('Retry')}
                </RetryButton>
            </Inner>
        </Wrapper>
    );
};

export default GenericErrorRetry;
